export enum EExhibitAsideLinks {
  TEXT,
  TOPIC,
  GUIDE,
}
